export const environment = {
  production: true,
  authTimeout: 60_000
};
